<template>
  <side-bar
    v-show="isSidebarActiveLocal"
    position-right
    class="z-10 max-w25 cust-overflow-y-primary-color custoverflowheth"
  >
    <div
      class="flex sidebar-topfixpart bg-primary justify-between p-4 add-sidebar-top"
    >
      <h2 class="h2-class font-semibold text-white uppercase">
        {{ dataType }} Coupon Code
      </h2>

      <feather-icon
        icon="XIcon"
        @click="
          isSidebarActiveLocal = false;
          onReset();
        "
        class="cursor-pointer text-white"
        svgClasses="w-6"
      ></feather-icon>
    </div>
    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(handleClick)">
        <div class="p-4 mt-12">
          <div class="mb-2">
            <p class="font-semibold text-sm mb-2">
              Coupon Name<span class="text-danger pl-1">*</span>
            </p>
            <b-form-group class="formmb">
              <base-input
                name="Coupon Name"
                :rules="{
                  alpha_spaces: true,
                  required: true,
                }"
                placeholder="Enter Coupon Name"
                v-model="couponName"
              ></base-input>
              <!-- <span v-if="nameErr" class="small text-danger">{{
                 msg.name
                }}</span> -->
            </b-form-group>
          </div>
          <div class="mb-2">
            <p class="font-semibold text-sm mb-2">
              Coupon discount %<span class="text-danger pl-1">*</span>
            </p>
            <b-form-group class="formmb">
              <base-input
                name="Coupon discount %"
                :rules="{
                  numeric: true,
                  required: true,
                  regex: '^(0?[1-9]|[1-9][0-9])$',
                }"
                placeholder="Enter Coupon Discount In %"
                v-model="discountPercentage"
              ></base-input>
            </b-form-group>
            <!-- <span v-if="discErr" class="small text-danger">{{
              msg.disc
            }}</span> -->
          </div>

          <div class="mb-2">
            <p class="font-semibold text-sm mb-2">
              Coupon Code<span class="text-danger pl-1">*</span>
            </p>
            <b-form-group class="formmb">
              <base-input
                name="Coupon Code"
                :rules="{
                  alpha_num: true,
                  required: true,
                }"
                placeholder="Enter Coupon Code"
                v-model="couponCode"
              ></base-input>
            </b-form-group>
            <!-- <span v-if="ccErr" class="small text-danger">{{ msg.cc }}</span> -->
          </div>
          <div class="mb-2">
            <p class="font-semibold text-sm mb-2">
              Start Date<span class="text-danger pl-1">*</span>
            </p>
            <b-form-group class="formmb">
              <base-input
                class="cust-mb"
                type="date"
                value=""
                id="start-date"
                placeholder="Start Date"
                v-model="startDate"
                :rules="{
                  required: true,
                }"
              ></base-input>
            </b-form-group>
          </div>
          <div class="mb-2">
            <p class="font-semibold text-sm mb-2">
              End Date<span class="text-danger pl-1">*</span>
            </p>
            <b-form-group class="formmb">
              <base-input
                class="cust-mb"
                type="date"
                value=""
                id="end-date"
                placeholder="End Date"
                v-model="expiryDate"
                :rules="{
                  required: true,
                }"
              ></base-input>
            </b-form-group>
          </div>

          <div class="mb-2">
            <p class="font-semibold text-sm mb-2">
              Total user limit<span class="text-danger pl-1">*</span>
            </p>
            <b-form-group class="formmb">
              <base-input
                name="Total user limit"
                :rules="{
                  numeric: true,
                  required: true,
                }"
                placeholder="Enter Total user limit"
                v-model="discountLimit"
              ></base-input>
            </b-form-group>
            <!-- <span v-if="limitErr" class="small text-danger">{{
              msg.limit
            }}</span> -->
          </div>

          <div class="mb-2">
            <p class="font-semibold text-sm mb-2">
              Select Plan<span class="text-danger pl-1">*</span>
            </p>
            <b-form-group class="formmb">
              <b-form-select
                v-model="selectedMembership"
                placeholder="Select"
                class="w-full"
                required
              >
                <b-form-select-option
                  v-for="item in get_all_membership"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id"
                >
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </div>
        </div>
        <footer class="footer-fix fixed bottom-0 w-1/4">
          <base-button
            block
            class="rounded-none font-semibold"
            type="primary"
            native-type="submit"
            variant="primary"
            >SUBMIT</base-button
          >
          <!-- @click="handleClick(dataType)" -->
        </footer>
      </b-form>
    </validation-observer>
  </side-bar>
</template>
<script>
import FileUploader from "@/components/FileUploader.vue";
import { mapState } from "vuex";
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    dataType: {
      type: String,
      required: true,
    },
    editCouponData: {
      type: Object,
    },
  },

  data() {
    return {
      commissionType: "",
      couponName: "",
      discountPercentage: 0,
      couponCode: "",
      startDate: "",
      expiryDate: "",
      discountLimit: "",
      maxDate: null,
      nameErr: false,
      selectedMembership: null,
      membershipFilter: [],
      msg: {},
    };
  },
  components: {
    FileUploader,
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
    ...mapState("subscribe", {
      get_all_membership: "get_all_membership",
    }),
  },
  watch: {
    editCouponData(val) {
      if (val && this.isSidebarActiveLocal) {
        this.init();
      }
    },
    isSidebarActiveLocal(val) {
      this.$refs.formValidator.reset();
    },
  },
  methods: {
    handleClick(val) {
      try {
        if (this.dataType === "Edit") {
          this.onEdit();
        } else {
          this.onSubmit();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async onSubmit() {
      if (!/^(0|[1-9]\d*)$/.test(this.discountPercentage)) {
        this.$swal.fire({
          text: "Discount Percentage should have correct value",
          // icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      let payload = {
        couponName: this.couponName.trim(),
        discountPercentage: this.discountPercentage,
        couponCode: this.couponCode.trim(),
        startDate: this.startDate,
        expiryDate: this.expiryDate,
        discountLimit: this.discountLimit,
        planId: this.selectedMembership,
      };
      let loader = this.$loading();
      try {
        let addData = await this.$store.dispatch(
          "subscribe/CreateCoupon",
          payload
        );
        await this.$store.dispatch("subscribe/GetCoupon");
        // this.$emit("getAllCoupon");

        if (addData.code == 200) {
          this.$swal.fire({
            text: "Coupon Added Successfully",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        }
        this.isSidebarActiveLocal = false;

        this.onReset();
      } catch (err) {
        console.log(object);
        if (err) {
          loader.close();
        }
      }
    },

    async onEdit() {
      if (!/^(0|[1-9]\d*)$/.test(this.discountPercentage)) {
        this.$swal.fire({
          text: "Discount Percentage should have correct value",
          // icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      let payload = {
        couponName: this.couponName.trim(),
        discountPercentage: this.discountPercentage,
        couponCode: this.couponCode.trim(),
        startDate: this.startDate,
        expiryDate: this.expiryDate,
        discountLimit: this.discountLimit,
        planId: this.selectedMembership,
        _id: this.editCouponData._id,
      };
      let loader = this.$loading();
      try {
        let addData = await this.$store.dispatch(
          "subscribe/UpdateCoupon",
          payload
        );
        // await this.$store.dispatch("subscribe/GetCoupon");
        this.$emit("getAllCoupon");

        if (addData.code == 200) {
          this.$swal.fire({
            text: "Coupon successfully edited",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        }
        this.isSidebarActiveLocal = false;

        this.onReset();
      } catch (err) {
        console.log(object);
        if (err) {
          loader.close();
        }
      }
    },

    onReset() {
      // event.preventDefault();
      this.couponName = "";
      this.discountPercentage = "";
      this.couponCode = "";
      this.startDate = "";
      this.expiryDate = "";
      this.discountLimit = "";
      this.selectedMembership = null;
      this.isSidebarActiveLocal = false;
      this.$nextTick(() => {
        this.$refs.formValidator.reset();
      });
    },
    formatDate(val) {
      const date = new Date(val);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    async init() {
      this.$refs.formValidator.reset();
      if (this.dataType === "Edit") {
        this.couponName = this.editCouponData.couponName;
        this.discountPercentage = this.editCouponData.discountPercentage;
        this.couponCode = this.editCouponData.couponCode;
        this.startDate = this.formatDate(this.editCouponData.startDate);
        this.expiryDate = this.formatDate(this.editCouponData.expiryDate);
        this.discountLimit = this.editCouponData.discountLimit;
        this.selectedMembership = this.editCouponData.planId._id;
      }
    },
  },
};
</script>
<style>
.custoverflowheth {
  height: 630px;
  overflow-y: auto !important;
}
.custoverflowheth::-webkit-scrollbar {
  width: 0px !important;
}
</style>
